import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { EMPTY, map, merge, Subject, switchMap, takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AprPiHistoricalDataModalComponent } from 'app/modules/annulus-pressure-record/components/historical-pi-data-modal/historical-pi-data-modal.component';
import module from "app/modules/annulus-pressure-record/annulus-pressure-record.module";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UntypedFormGroup } from '@angular/forms';
import { AprSearchStateService } from '../../state/search.state';

@Component({
  selector: 'aprPi-table',
  templateUrl: './apr-pi-table.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./apr-pi-table.component.scss']
})

export class AprPiTableComponent {
  @ViewChild(MatPaginator) private _paginator: MatPaginator;
  @ViewChild(MatSort) private _sort: MatSort;

  @Input() dt: any
  @Input() startingIndex: number = 0
  @Input() searchForm: UntypedFormGroup

  @Output() setPage = new EventEmitter<any>();
  @Output() onSort = new EventEmitter<any>();

  isLoading: boolean = false
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  isPsi: boolean = false

  constructor(
    private dialog: MatDialog,
    public router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
    private state: AprSearchStateService,
  ) {}

  ngAfterViewInit() {
    if (this._sort && this._paginator) {
      // Set the initial sort
      this._sort.sort({
        id: 'field',
        start: 'asc',
        disableClear: true,
      });

      // Mark for check
      this._changeDetectorRef.markForCheck();

      // If the user changes the sort order...
      this._sort.sortChange
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(() => {
          // Reset back to the first page
          this._paginator.pageIndex = 0;

          this.onSort.emit(this._sort)
        });


      // Get platform types if sort or page changes
      merge(this._sort.sortChange, this._paginator.page).pipe(
        switchMap(() => {
          // this.isLoading = true;

          // this.startingIndex = this._paginator.pageIndex * this._paginator.pageSize;

          let pageInfo = {
            'count': this._paginator.length,
            'pageSize': this._paginator.pageSize,
            'limit': this._paginator.pageSize,
            'offset': this._paginator.pageIndex
          }
          this.setPage.emit(pageInfo); // Emit page number

          return EMPTY
        }),
        map(() => {
          this.isLoading = false;
        }),
      ).subscribe();
    }
  }

  openHistoricalModal(wellDetails) {
    const dialogRef = this.dialog.open(AprPiHistoricalDataModalComponent, {
      data: wellDetails,
      width: "90%",
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }


  viewPiRecord(row) {
    if (this.searchForm.dirty) this.state.set(this.searchForm.value);
    this.router.navigate([`/data-management/annulus-pressure-record/${row.id}/view`]);
  }

  handleFormatDate(dateString: string, withTime) {
    return handleFormatDate(dateString, withTime)
  }

  onPage(event: any) {
    this.setPage.emit(event); // Emit page number
  }

  handleThpPhpValue(value: any, isScanOff: any) {
    if (!value) {
      if (isScanOff) {
        return 'Scan Off'
      } else {
        return 'N/A'
      }
    }

    return value.toFixed(2);
  }

  changeConversion(){
    this.isPsi = !this.isPsi
  }
}
